import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-login-mall",
  "use": "icon-login-mall-usage",
  "viewBox": "0 0 4814 1624",
  "content": "<symbol viewBox=\"0 0 4814 1624\" id=\"icon-login-mall\">\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/login-mall.svg
// module id = xzZT
// module chunks = 44